import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { ProfileOutlined } from '@ant-design/icons';
import { CardLayout, cardLayoutOptions } from '../../Layout';
import { MonthlyOrderAddOrder } from './MonthlyOrderAddOrder';
import { MonthlyOrderOrdersTable } from './MonthlyOrderOrdersTable';
import { IIdSpinners, monthlyOrderStatuses } from '../../../interfaces';
import { useUiIsSpinnerFound } from '../../../hooks';
import { useMonthlyOrder } from '../../../hooks/stores/useMonthlyOrderStores';

export const MonthlyOrderOrdersListEdit: React.FC<IIdSpinners> = observer(({ idSpinners = [] }: IIdSpinners) => {
    const [isHasNew, setIsHasNew] = useState<boolean>(true);
    const { linkedOrders, status: monthlyOrderStatus } = useMonthlyOrder();
    const isLoading = useUiIsSpinnerFound(idSpinners);
    const addOrder = () => {
        setIsHasNew(false);
    };

    return (
        <CardLayout
            columnOption={cardLayoutOptions.cardInfoEdit}
            count={linkedOrders?.length}
            icon={<ProfileOutlined />}
            idSpinners={idSpinners}
            isTable
            onClickAddButton={
                isHasNew && !isLoading && monthlyOrderStatus === monthlyOrderStatuses.DRAFT ? addOrder : undefined
            }
            title={'Orders'}
        >
            {isHasNew ? null : (
                <MonthlyOrderAddOrder
                    onFinish={() => {
                        setIsHasNew(true);
                    }}
                />
            )}
            <MonthlyOrderOrdersTable isLoading={isLoading} />
        </CardLayout>
    );
});
